var React = require('react');

function YoutubeCircularPlayButton (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Circle","fill":"#ff0000","stroke":"#ff0000","strokeWidth":"1","d":"M 0.00,200.00\n           C 0.00,89.50 89.50,0.00 200.00,0.00\n             310.50,0.00 400.00,89.50 400.00,200.00\n             400.00,310.50 310.50,400.00 200.00,400.00\n             89.50,400.00 0.00,310.50 0.00,200.00","key":0}),React.createElement("path",{"id":"Triaangle","fill":"#ffffff","stroke":"#ffffff","strokeWidth":"1","d":"M 156.78,247.19\n           C 156.78,247.19 156.19,143.77 156.19,143.77\n             156.19,143.77 258.43,196.20 258.43,196.20\n             258.43,196.20 156.78,247.19 156.78,247.19 Z\n           M 26.45,361.65","key":1})]);
}

YoutubeCircularPlayButton.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 400 400","xmlSpace":"preserve"};

module.exports = YoutubeCircularPlayButton;

YoutubeCircularPlayButton.default = YoutubeCircularPlayButton;
